module.exports = __webpack_public_path__ + "banner.cf9bdddd.png";